export const style0 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"#D4C2ED", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid #D4C2ED", 
    borderRadius: "1.64px",
    color:"black",
    cursor:"default",
}
export const style1 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"#725798", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid #725798", 
    borderRadius: "1.64px",
    color:"white",
    cursor:"default",
}
export const style2 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"pink", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid pink", 
    borderRadius: "1.64px",
    cursor:"default",
}
export const style3 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"black", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid black", 
    borderRadius: "1.64px",
    color:"white",
    cursor:"default",
}
export const style4 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"#634889", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid #634889", 
    borderRadius: "1.64px",
    color:"white",
    cursor:"default",
}
export const style5 = {
    position:"absolute",
    left:"70px", 
    backgroundColor:"#BB8AFF", 
    width:"25px",
    display: "flex",
    alignItems: "center", 
    justifyContent: "center",
    border: "1px solid #BB8AFF", 
    borderRadius: "1.64px",
    color:"white",
    cursor:"default",
}